declare global {
  interface Number {
    toEuros(): string;
  }
}

Number.prototype.toEuros = function() {
  return (this.valueOf() / 100).toFixed(2);
};

export {};